import { uploadFileToS3 } from './uploadFileToS3'

// Quill emitter sources (Quill.sources), inlined so this module loads without Quill (jest).
const USER = 'user'
const SILENT = 'silent'

// Same types as the S3 upload policy accepts for the toolbar image button.
export const PASTED_IMAGE_MIMETYPES = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
]

// IMP-13742: images pasted inside HTML (Google Docs, Word, web pages) can carry their bytes as a
// base64 `data:` URI, which used to be stored as-is and made briefs weigh several MB. Drop them;
// images with a regular URL are kept. `delta.constructor` is Quill's Delta class.
export const dropInlineImageMatcher = (node, delta) =>
  /^data:/i.test(node.getAttribute('src') || '')
    ? new delta.constructor()
    : delta

// IMP-13742: replaces Quill's default uploader handler, which inlined pasted/dropped image files
// as base64. Files are uploaded to S3 and inserted as an imageBlot pointing at their URL.
// Without media support (or S3 config) the paste is ignored.
export function createPastedImagesHandler({ getQuill, s3Config, allowMedia }) {
  return async (range, files) => {
    const quill = getQuill()
    if (!quill || !allowMedia || !s3Config?.bucket) return

    try {
      const sources = await Promise.all(
        files.map(file => uploadFileToS3(file, s3Config))
      )
      quill.deleteText(range.index, range.length, USER)
      sources.forEach((src, offset) => {
        quill.insertEmbed(range.index + offset, 'imageBlot', { src }, USER)
      })
      quill.setSelection(range.index + sources.length, SILENT)
    } catch (err) {
      console.error(err)
    }
  }
}
